import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ReactElement, ReactNode } from 'react';

export function Tooltip({ children, content }: { children: ReactElement; content: ReactNode }) {
  return <TooltipPrimitive.Provider delayDuration={350}><TooltipPrimitive.Root>
    <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
    <TooltipPrimitive.Portal><TooltipPrimitive.Content sideOffset={5} className="z-[10002] max-w-xs rounded-md bg-gray-900 px-2.5 py-1.5 text-xs text-white shadow-md">{content}<TooltipPrimitive.Arrow className="fill-gray-900" /></TooltipPrimitive.Content></TooltipPrimitive.Portal>
  </TooltipPrimitive.Root></TooltipPrimitive.Provider>;
}
